import { Divider, Radio } from "antd";
import { useContext, useEffect, useState } from "react";
import { getBeneficiaryForDisbursementsScreen } from "../../api/NetworkingBeneficiaries";
import { saveDealHeader, validateCustomerAndContactLimits } from "../../api/NetworkingDeals";
import AppContext from "../../App.context";
import { formatToCurrency } from "../../helpers/FormatHelper";
import { getResource } from "../../helpers/ResourcesHelper";
import { Disbursement } from "../models/Disbursement";
import { ApprovalOption } from "../orders/OrdersScreen";
import ConfirmationModal from "../others/ConfirmationModal";
import QuoteBox from "../rates/quoteBox/QuoteBox";
import DisbursementsForm from "./DisbursementsForm";
import { PaymentTransactionContextProvider, usePaymentTransactionContext } from "./PaymentTransactionContext";
import { TransactionInfo } from "./TransactionInfo";
import TransactionSummary from "./TransactionSummary";

export interface OrderOneStepScreenType {
  disbursements?: Disbursement[],  
  buyCurrency?: string,
  lockedSide?: string,
  disbursementInfoAsParameter?: boolean,
  fromBalances?: boolean
}

const OrderOneStepForm = (props: OrderOneStepScreenType) => {

  const { disbursementInfoAsParameter, fromBalances } = props

  const { showLoadingModal, hideLoadingModal, showModal } = useContext(AppContext);  

  // const [refresh, setRefresh] = useState(false);

  const {
    buyCurrency,
    buyCurrencyInfo,
    disbursements,
    lockedSide,
    totalPayment,
    totalSettlement,
    sellCurrency,
    sellCurrencyInfo,
    settlementMethod,
    setBeneficiaries,
    setBuyCurrency,
    setDisbursements,
    setLockedSide,
    setDisbursementInfoAsParameter,
    setFromBalances,
    setValidateInput,
    valueDate,
    setCustomerRate,
    setQuoted,
    dealHeaderId } = usePaymentTransactionContext();

  const [showConfirmModalValidation, setShowConfirmModalValidation] = useState<boolean>(false);
  const [confirmationModalTitle, setConfirmationModalTitle] = useState('');
  const [confirmationModalMessage, setConfirmationModalMessage] = useState('');

  // useEffect(() => { setRefresh(!refresh) }
  //   , [buyCurrency]
  // );

  if (props.buyCurrency && props.buyCurrency !== '') {
    setBuyCurrency(props.buyCurrency)
  }

  if (disbursements !== undefined && props.disbursements !== undefined) {
    setDisbursements(props.disbursements)
  }

  setDisbursementInfoAsParameter(disbursementInfoAsParameter || false)
  setFromBalances(fromBalances || false)

  if (props.lockedSide !== undefined && props.lockedSide !== '') {
    setLockedSide(props.lockedSide || '')
  }  

  const customerId = JSON.parse(localStorage.getItem('UserSession')!)['CustomerID'];

  useEffect(() => {
    const load = async () => {

      showLoadingModal()
      let jsonBenes = await getBeneficiaryForDisbursementsScreen(customerId, buyCurrency || '');
      hideLoadingModal()
      console.log('jsonBenes: ', jsonBenes)

      if (jsonBenes.beneficiaries) {
        let benes = jsonBenes.beneficiaries.filter((item: any) => item.BeneficiaryStatus === 'Authorized').map((c: any) => ({ ...c, label: c.Description, value: c.Value, BeneficiaryType: 0 }));
        benes.push({ label: getResource('SelectBeneficiary'), value: '' });
        setBeneficiaries(benes);
      }
      else {
        setBeneficiaries([]);
      }
    }
    load()
  }, [buyCurrency, customerId])

  const onChangeLockedSide = (event: any) => {
    if (Array.isArray(disbursements)) {
      if (event.target.value === 'buy') {
        disbursements.forEach(x => { x.otherAmount = 0; x.fee = 0 })
      } else {
        disbursements.forEach(x => { x.amount = 0;; x.fee = 0 })
      }
    }
    setLockedSide(event.target.value);
  }

  const saveDeal = async (status: string, rateQuoteID: string, customerRate: number, marketRate: number, profit: number, coverCustomerID: number, externalInterface: string, externalInterfaceType: string, rateTerms: string, jsonProperties: string) => {

    showLoadingModal();
    //Status
    let userSession = JSON.parse(localStorage.getItem('UserSession')!);

    let dealStatus = userSession.DealApproveRequired ? 'Pending for Approval' : 'Accepted';
    if (status === 'Work in Progress') {
      dealStatus = status;
    }

    let outgoingFunds: any[] = [];

    (disbursements || []).forEach((disbursement: Disbursement, index: number) => {
      let outgoing = {
        DealHeaderID: dealHeaderId,
        ValueDate: valueDate,
        UpdateToken: 0,
        BeneficiaryID: disbursement.beneficiaryId,
        BeneficiaryBankAccountID: disbursement.bankAccountId,
        OutgoingFundsID: 0,
        PaymentAmount: disbursement.amount,
        PaymentInstrument: disbursement.instrument,
        PaymentReference: disbursement.reference,
        Status: 'Pending',
        WireItemFee: disbursement.fee,
        WireItemFeeCurrencyID: sellCurrency,
      }
      outgoingFunds.push(outgoing);
    });

    let objDealHeader: any = {
      BuyAmount: totalSettlement,
      BuyCurrency: sellCurrency,
      CoverCustomerID: coverCustomerID,
      CustomerContactID: JSON.parse(localStorage.getItem('UserSession')!).ContactID,
      CreatedBy: localStorage.getItem('UserID'),
      CustomerID: JSON.parse(localStorage.getItem('UserSession')!).CustomerID,
      CustomerRate: customerRate,
      CustomerRefNo: '',
      ExternalInterface: externalInterface,
      ExternalInterfaceType: externalInterfaceType,
      DealHeaderID: dealHeaderId,
      LockedSide: lockedSide === 'buy' ? 'Sell' : 'Buy',
      MarketRate: marketRate,
      OutgoingFunds: outgoingFunds,
      ProfitAmount: profit,
      RateQuoteID: rateQuoteID,
      SellAmount: totalPayment,
      SellCurrency: buyCurrency,
      Status: dealStatus,
      DealOrigin: "Online Deal",
      DealType: 1,
      UpdateBuyAmountField: lockedSide === 'sell' ? true : false,
      UpdatedBy: localStorage.getItem('UserID'),
      UpdateToken: 0,
      ValueDate: valueDate,
      SettlementDeliveryMethods: settlementMethod,
      IncomingFunds: [{
        IncomingFundsID: 0,
        Amount: totalSettlement,
        BankAccountID: 0,
        SettlementInstrument: settlementMethod
      }]
    }

    let responseLimit = await validateCustomerAndContactLimits(objDealHeader.DealType, totalPayment, sellCurrency, objDealHeader.CustomerID, Number(objDealHeader.CustomerContactID));
    let alertTitle = '';
    let alertMessage = '';

    if (responseLimit.httpStatusCode === 200) {
      if (responseLimit.ValidationMessage === '') {
        callSaveDealHeader(objDealHeader);
      }
      else {
        if (responseLimit.LimitValidationStatus.toLowerCase() === 'warning') {
          setConfirmationModalTitle(getResource('Title.Warning'));
          setConfirmationModalMessage(responseLimit.ValidationMessage);
          setShowConfirmModalValidation(true);
        }
        else {
          alertTitle = getResource('Js_MessageError_TitleError');
          alertMessage = responseLimit.ValidationMessage;
          showModal(alertTitle, alertMessage);
          hideLoadingModal();
        }
      }
    }
    else {
      alertTitle = getResource('Js_MessageError_TitleError');
      alertMessage = getResource('Js_Message_TryAgainOrContactAdministrator');
      showModal(alertTitle, alertMessage);
      hideLoadingModal();
    }
  }


  const callSaveDealHeader = (objDealHeader: any) => {
    saveDealHeader(objDealHeader).then(
      (responseSaveDealHeader) => {
        let alertTitle = getResource('Js_MessageError_TitleError');
        let alertMessage = getResource('Message_DealError');

        if (responseSaveDealHeader !== undefined) {
          switch (Number(responseSaveDealHeader.httpStatusCode)) {
            case 200: {
              let userRequiredForAcceptance = false;
              let auxApprovalOptions: ApprovalOption = {
                Approvals: '',
                DealHeaderID: 0
              };
              alertTitle = getResource('Js_MessageError_TitleSuccess');
              switch (responseSaveDealHeader.Status) {
                case 'Accepted': {
                  alertMessage = getResource('Message_OrderCommitted').replace('DealHeaderID', responseSaveDealHeader.DealHeaderID);

                  if (responseSaveDealHeader.HeldFundBalance != null && responseSaveDealHeader.HeldFundBalance !== undefined && responseSaveDealHeader.HeldFundBalance > -1) {
                    alertMessage = alertMessage + " " + getResource('YourCurrentBalance') + " " + formatToCurrency(responseSaveDealHeader.HeldFundBalance, undefined, sellCurrencyInfo.NumberOfDecimals) + ' ' + sellCurrency;
                  }
                  if (responseSaveDealHeader.LimitValidationMessage !== undefined && responseSaveDealHeader.LimitValidationMessage !== undefined) {
                    alertMessage = alertMessage + " , " + responseSaveDealHeader.LimitValidationMessage;
                  }
                  break;
                }
                case 'Pending for Approval': {
                  alertMessage = getResource('Message_OrderCommitted').replace('DealHeaderID', responseSaveDealHeader.DealHeaderID);
                  let approvals = responseSaveDealHeader.ApprovalsJson;
                  if (approvals === undefined) {
                    approvals = '';
                  }
                  if (approvals === '') {
                    alertTitle = getResource('Js_MessageError_TitleError');
                    alertMessage = getResource('Message_DealMissingApprovals');
                  } else {
                    auxApprovalOptions = {
                      Approvals: approvals,
                      DealHeaderID: responseSaveDealHeader.DealHeaderID
                    };
                  }
                  break;
                }
                case 'Pending':
                  alertMessage = getResource('Message_OrderSavedAsPending').replace('DealHeaderID', responseSaveDealHeader.DealHeaderID);

                  let complianceRulesFound = responseSaveDealHeader !== undefined &&
                    ((responseSaveDealHeader.ComplianceSoftRules !== undefined && responseSaveDealHeader.ComplianceSoftRules !== null
                      && Array.isArray(responseSaveDealHeader.ComplianceSoftRules) && responseSaveDealHeader.ComplianceSoftRules.length > 0)
                      ||
                      (
                        responseSaveDealHeader.ComplianceRules !== undefined && responseSaveDealHeader.ComplianceRules !== null
                        && Array.isArray(responseSaveDealHeader.ComplianceRules) && responseSaveDealHeader.ComplianceRules.length > 0)
                    )

                  if (complianceRulesFound) {
                    alertMessage = getResource('Message_DealCompliance');
                  } else {
                    alertMessage = alertMessage + responseSaveDealHeader.MessagePending;
                  }

                  showModal(alertTitle, alertMessage);
                  break;
                default:
                  alertMessage = getResource('Message_OrderSaved').replace('DealHeaderID', responseSaveDealHeader.DealHeaderID);
                  break;

              }
              hideLoadingModal();
              if (!userRequiredForAcceptance) {
                showModal(alertTitle, alertMessage);
              }
              break;
            }
            default:
              if (responseSaveDealHeader.ValidationMessage !== undefined) {
                //validation message from API
                alertTitle = getResource('Js_MessageError_TitleValidation');
                alertMessage = responseSaveDealHeader.ValidationMessage;
              }
              else {
                if (responseSaveDealHeader.httpErrorMessage !== undefined) {
                  //message from networking based on status code
                  alertMessage = responseSaveDealHeader.httpErrorMessage;
                }
              }

              if (responseSaveDealHeader.Message === 'SentToInterface') {
                alertMessage = getResource('Message_DealErrorSentInterface');
              }
              setQuoted(false);
              hideLoadingModal();
              showModal(alertTitle, alertMessage);
              break;

          }
        } else {
          hideLoadingModal();
          showModal(alertTitle, alertMessage);
        }
      }
    );
  }

  const yesLimitValidationAlert = () => {
    setShowConfirmModalValidation(false);
  }

  const closeLimitValidationAlert = () => {
    hideLoadingModal();
    setShowConfirmModalValidation(false);
    setQuoted(false);
  }

  return <>
    <div className="title-text"><h2>{getResource('Title.Payments')}</h2></div>
    <div className="row">
      <div className="col-md-4 col-xs-12">
        <TransactionInfo />
      </div>
      <div className="col-md-1"></div>
      <div className="col-md-4 col-xs-12">
        <TransactionSummary />
      </div>
      <div className="col-md-3 col-xs-12">
        {/* <button style={{ padding: '30px', margin: 'auto', width: '75%', marginTop: '20px' }} onClick={() => setValidateInput(true)}>Quote</button> */}
        <QuoteBox
          type={'order'}
          mode={'modal'}
          dealType={1}
          buyCurrency={buyCurrency}
          sellCurrency={sellCurrency}
          customerID={Number.parseInt(JSON.parse(localStorage.getItem('UserSession')!).CustomerID)}
          contactID={Number.parseInt(JSON.parse(localStorage.getItem('UserSession')!).ContactID)}
          valueDate={valueDate}
          forwardNearDate={valueDate}
          amount={lockedSide === 'buy' ? totalPayment : totalSettlement}
          lockedSide={lockedSide === 'buy' ? 'sell' : 'buy'}
          totalFeesAmount={0}
          amountCalc={(calculatedAmount: number) => {
            console.log('calculatedAmount ', calculatedAmount)
            let currencyDecimals = 2
            if (lockedSide === 'buy' && buyCurrencyInfo !== undefined) {
              currencyDecimals = buyCurrencyInfo.NumberOfDecimals
            } else if (lockedSide === 'buy' && sellCurrencyInfo !== undefined) {
              currencyDecimals = sellCurrencyInfo.NumberOfDecimals
            }
            //let sAmount = calculatedAmount.toFixed(currencyDecimals)
            //setTotalSettlement(Number(sAmount));

            if (Array.isArray(disbursements)) {
              disbursements.forEach(x => {

                console.log('x.amount ', x.amount)
                console.log('calculatedAmount ', calculatedAmount)
                console.log('totalPayment ', totalPayment)
                console.log('totalSettlement ', totalSettlement)

                if (lockedSide === 'buy') {
                  x.otherAmount = Number((x.amount * (calculatedAmount / totalPayment)).toFixed(currencyDecimals));
                } else {
                  x.amount = Number(((x.otherAmount || 0) * (calculatedAmount / totalSettlement)).toFixed(currencyDecimals));
                }
              });
            }
          }}
          atTheSameTimeToClickQuote={() => { setQuoted(true); }}
          returnDataFromModal={true}
          onTimeNoEnd={(rateQuoteID: string, customerRate: number, marketRate: number, profit: number, coverCustomerID: number, externalInterface: string, externalInterfaceType: string, rateTerms: string) => {
            console.log('customerRate ', customerRate)
            setCustomerRate(customerRate);
            /*setRateQuoteID(rateQuoteID);
            
            setMarketRate(marketRate);
            setProfit(profit);
            setCoverCustomerID(coverCustomerID);
            setExternalInterface(externalInterface);
            setExternalInterfaceType(externalInterfaceType);
           calculateFees(customerRate, rateTerms, customerRate);
  
            const auxShowAddProp = [...showAddProp];
            auxShowAddProp.forEach(element => {
              element.show = false;
            });
            setShowAddProp(auxShowAddProp);*/
          }}
          onAcceptClick={(rateQuoteID: string, customerRate: number, marketRate: number, profit: number, coverCustomerID: number, externalInterface: string, externalInterfaceType: string, rateTerms: string, jsonProperties: string) => {
            saveDeal('', rateQuoteID, customerRate, marketRate, profit, coverCustomerID, externalInterface, externalInterfaceType, rateTerms, jsonProperties); setQuoted(false);
          }
          }
          onCancelQuote={() => { setQuoted(false); }}
          validateFields={() => {
            setValidateInput(true)
            return true;
            /*
            let [isvalid, lines] = valdiatePrevRows(false, true);
            console.log(isvalid)
            return isvalid;*/
          }}
          onError={() => { setQuoted(false); }}
          showConfirmation={true}
          confirmationMessage={''}
          confirmationTitle={getResource('OrderConfirmation_Title')}
          onQuoteClick={(f: any) => { }}
        />
      </div>
    </div>
    <div className="row">
      <div className="col-md-5"></div>
      <div className="col-md-5">
        <Radio.Group
          onChange={onChangeLockedSide}
          value={lockedSide}
          buttonStyle="solid"
          size="middle"
          disabled={disbursementInfoAsParameter/*quoted*/}
        >
          <Radio.Button value={'buy'} >{getResource('Form.Label.LockBuySide')}</Radio.Button>
          <Radio.Button value={'sell'} >{getResource('Form.Label.LockSellSide')}</Radio.Button>
        </Radio.Group></div>
      <div className="col-md-2">
      </div>
      <Divider />
      <DisbursementsForm />
      <ConfirmationModal visible={showConfirmModalValidation} cancel={closeLimitValidationAlert} confirm={yesLimitValidationAlert} mainTitle={confirmationModalTitle} title={confirmationModalMessage} />
    </div>
  </>
}

const OrderOneStepScreen = (props: OrderOneStepScreenType) => {

  console.log('OrderOneStepScreen', props)

  return <PaymentTransactionContextProvider>
    <OrderOneStepForm {...props} />
  </PaymentTransactionContextProvider>
}

export default OrderOneStepScreen